import { useTranslation } from 'react-i18next';

import { UsersDataGrid } from '~features/users';
import UsersOverviewContainer from '~features/users/containers/usersOverviewContainer';

import Page from '../page';

const UsersPage = () => {
	const { t } = useTranslation();

	return (
		<Page title={t('users')}>
			{/* <UsersDataGrid /> */}
			<UsersOverviewContainer />
		</Page>
	);
};

export default UsersPage;
